// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://psvghgwvcokmgqejmgfz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBzdmdoZ3d2Y29rbWdxZWptZ2Z6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkyNzU1NzYsImV4cCI6MjA1NDg1MTU3Nn0.LQpl9M-SeLba6GOHOdR2cTfReMA7WdVn4d3htcVc38Y";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);